export class LanguageInfo  {

  private _code : string= "";
  private _localMessageFileName : string= "";
  private _default : boolean = true;
  private _displayName : string = "";

  constructor(code : string, dispalyName : string, localMessageFileName: string,  isDefault: boolean = false) 
  {
    this._code = code.toLowerCase();
    this._localMessageFileName = localMessageFileName
    this._default = isDefault;

    this._displayName = dispalyName === "" ? code : dispalyName;
  }

  get code() : string
  {
    return this._code;
  }

  get localMessageFileName() : string
  {
    return this._localMessageFileName;
  }

  get displayName() : string
  {
    return this._displayName;
  }

  get isDefault(): boolean
  {
    return this._default;
  }
}

export type LocalizationInfo = {
  localMessageResourcePath : string;
  languages: Array<LanguageInfo>;
};

